export const API = "https://api.thyba.finance"
export const host = "https://thyba.finance"